import { render, staticRenderFns } from "./ContainerLabel.vue?vue&type=template&id=85f6c46a&"
import script from "./ContainerLabel.vue?vue&type=script&lang=js&"
export * from "./ContainerLabel.vue?vue&type=script&lang=js&"
import style0 from "./ContainerLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports